import { BrowserRouter, Route, Routes, Navigate } from 'react-router-dom';
import './App.css';
import './scss/cw-styles.scss';
import Header from './components/Header';
import Banner from './components/Banner';
import Portfolio from './components/Portfolio';
import Carousel from './components/Carousel';
import AboutMe from './components/AboutMe';
import Footer from './components/Footer';
import ScrollToTop from './components/ScrollToTop';

// Import your case study components
import InMoment from './components/InMoment';
import Max from './components/Max';

function App() {
  console.log(
    "%cWelcome to my portfolio!\n" +
    "%cFeel free to explore the code, just don't judge my variable names too harshly 😅",
    "color: #308273; font-size: 20px; font-weight: bold;",
    "color: #222222; font-size: 16px;",
  );

  const scrollToSection = (sectionId) => {
    // Small delay to ensure the home page components are mounted
    setTimeout(() => {
      const element = document.getElementById(sectionId);
      if (element) {
        element.scrollIntoView({ behavior: 'smooth' });
      }
    }, 100);
  };

  return (
    <div id="page_content_container">
      <BrowserRouter>
        <Header scrollToSection={scrollToSection} />
        <ScrollToTop />
        <Routes>
          <Route
            path="/"
            element={
              <>
                <Banner />
                <Portfolio />
                <Carousel />
                <AboutMe />
              </>
            }
          />
          <Route path="/case-studies/*" element={<CaseStudies />} />
          <Route path="*" element={<Navigate to="/" />} />
        </Routes>
      </BrowserRouter>
      <Footer />
    </div>
  );
}

function CaseStudies() {
  return (
    <Routes>
      <Route path="/" element={<Navigate to="inmoment" />} />
      <Route path="inmoment" element={<InMoment />} />
      <Route path="max" element={<Max />} />
      <Route path="*" element={<Navigate to="/" />} />
    </Routes>
  );
}

export default App;
